import {
  Download as DownloadIcon,
  Code as JsonIcon,
  TableChart as TableIcon,
} from "@mui/icons-material";
import {
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import React, { useState } from "react";
import { useExportProcessings } from "./OrionQueries";

function ExportMenu({
  assetIds,
  disabled = false,
}: {
  assetIds: string[];
  disabled?: boolean;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { mutate: downloadFile } = useExportProcessings();
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const exportOptions = [
    { format: "csv", label: "CSV", icon: <TableIcon /> },
    { format: "json", label: "JSON", icon: <JsonIcon /> },
    // { format: "xlsx", label: "Excel", icon: <ExcelIcon /> },
  ] as const;

  return (
    <>
      <Button
        variant="contained"
        size="small"
        startIcon={<DownloadIcon />}
        onClick={handleClick}
        disabled={disabled}
      >
        Export
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {exportOptions.map(({ format, label, icon }) => (
          <MenuItem
            key={format}
            onClick={() => downloadFile({ assetIds, format })}
          >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText>{label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default ExportMenu;
